/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plus_Bonus_Daily_ChallengeInputs */

const en_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily Bonus Challenge`)
};

const ar_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحدي اليومي الإضافي`)
};

const de_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tägliche Bonus-Herausforderung`)
};

const es_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafío diario extra`)
};

const fr_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Défi Quotidien Bonus`)
};

const it_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfida Giornaliera Bonus`)
};

const ja_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デイリーボーナスチャレンジ`)
};

const ko_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일일 보너스 챌린지`)
};

const pt_br_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafio diário bônus`)
};

const ru_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежедневное бонусное задание`)
};

const th_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความท้าทายพิเศษประจำวัน`)
};

const tr_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük Bonus Mücadele`)
};

const zh_cn_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日加码挑战`)
};

const zh_tw_plus_bonus_daily_challenge = /** @type {(inputs: Plus_Bonus_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日加碼挑戰`)
};

/**
* | output |
* | --- |
* | "Daily Bonus Challenge" |
*
* @param {Plus_Bonus_Daily_ChallengeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plus_bonus_daily_challenge = /** @type {((inputs?: Plus_Bonus_Daily_ChallengeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plus_Bonus_Daily_ChallengeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plus_bonus_daily_challenge(inputs)
	if (locale === "ar") return ar_plus_bonus_daily_challenge(inputs)
	if (locale === "de") return de_plus_bonus_daily_challenge(inputs)
	if (locale === "es") return es_plus_bonus_daily_challenge(inputs)
	if (locale === "fr") return fr_plus_bonus_daily_challenge(inputs)
	if (locale === "it") return it_plus_bonus_daily_challenge(inputs)
	if (locale === "ja") return ja_plus_bonus_daily_challenge(inputs)
	if (locale === "ko") return ko_plus_bonus_daily_challenge(inputs)
	if (locale === "pt_br") return pt_br_plus_bonus_daily_challenge(inputs)
	if (locale === "ru") return ru_plus_bonus_daily_challenge(inputs)
	if (locale === "th") return th_plus_bonus_daily_challenge(inputs)
	if (locale === "tr") return tr_plus_bonus_daily_challenge(inputs)
	if (locale === "zh_cn") return zh_cn_plus_bonus_daily_challenge(inputs)
	return zh_tw_plus_bonus_daily_challenge(inputs)
});